// https://dabernathy89.github.io/vue-query-builder/

import VueQueryBuilder from './VueQueryBuilder.vue'
export default VueQueryBuilder
